var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonutChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "donut__Property 1=Donut",
    className: "donut__Property donut__1=Donut"
  }, /*#__PURE__*/React.createElement("g", {
    id: "donut__Vector",
    className: "donut__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#919EAB",
    fillOpacity: 0.16,
    d: "M21.692 12a9.524 9.524 0 0 1-9.524 9.524A9.524 9.524 0 1 1 21.692 12ZM5.025 12a7.143 7.143 0 1 0 14.286 0 7.143 7.143 0 0 0-14.286 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596773",
    d: "M21.692 12a9.524 9.524 0 1 0-19.048 0 9.524 9.524 0 0 0 19.048 0Zm-2.857 0a6.667 6.667 0 1 0-6.667 6.667v.476a7.143 7.143 0 1 1 0-14.286 7.143 7.143 0 0 1 0 14.286v-.476A6.667 6.667 0 0 0 18.835 12Zm3.333 0c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0054EC",
    fillOpacity: 0.16,
    d: "M12.168 2.476a9.524 9.524 0 0 1 9.522 9.71l-2.38-.047a7.144 7.144 0 0 0-7.142-7.282v-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#011E60",
    d: "M12.168 2a10.001 10.001 0 0 1 9.998 10.194l-.01.477-3.332-.066.01-.476a6.667 6.667 0 0 0-6.666-6.796h-.476V2h.476Zm0 2.857a7.142 7.142 0 0 1 7.142 7.282l2.38.046a9.525 9.525 0 0 0-.507-3.256l-.164-.445a9.525 9.525 0 0 0-1.728-2.806l-.324-.347a9.524 9.524 0 0 0-2.679-1.917l-.433-.195a9.524 9.524 0 0 0-3.687-.743v2.381Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonutChart);
export default __webpack_public_path__ + "static/media/donut_chart.14909f4af9b2eeb66b465b8c4b39bbc2.svg";
export { ForwardRef as ReactComponent };